import getWidgetByName from "../requests";
import { Articles } from "../../articles/entities";
import {prop, take} from "ramda";

const getCuratedArticlesWidget = (articleIds) =>
  getWidgetByName("articlelistingcuratedwidget", articleIds.join(','))
    .then(Articles)
    .then(prop("articles"))

export { getCuratedArticlesWidget };
